import type { InventoryHit } from "../../lib/api/models";

/** One site or item hit: name, kind (or "Site"), serial number in mono, and the client it belongs to. */
export function InventoryLabel({ hit }: { hit: InventoryHit }) {
  return (
    <span className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
      <span className="font-medium text-ink">{hit.name}</span>
      <span className="text-xs text-ink-2">{hit.type === "site" ? "Site" : hit.kind}</span>
      {hit.serial ? <span className="font-mono text-xs text-ink-2">{hit.serial}</span> : null}
      <span className="ml-auto text-xs text-ink-3">{hit.clientName}</span>
    </span>
  );
}
